import { stringifyQs } from "@dashboard/utils/urls";

export const labelPrintingSection = "/label-printing/";
export const labelPrintingBatchesPath = `${labelPrintingSection}batches/`;
export const labelPrintingHelpPath = `${labelPrintingSection}help/`;
export const labelPrintingOverviewUrl = (params?: Record<string, string>) =>
  labelPrintingSection + (params ? "?" + stringifyQs(params) : "");

// What a product page or the product list hands to the label page:
// `productIds` (+ optional `variantIds` to narrow) are queued straight away;
// `pickProductId` offers that product's variants to choose from instead.
export type LabelPrintingLocationState = {
  productIds?: string[];
  variantIds?: string[];
  pickProductId?: string;
};
